import { pos_app_routes } from "../../constants/constants";
import { ACCESSIBLE_MUDULE_KEYS } from "../../constants/enum";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MyOrdersTable } from "./MyOrdersTable";



export const orderHistoryRoutes = [

    // ##################### Payment Received Route ############################
    {
        path: pos_app_routes.private.orders.userOrderHistory,
        exact: true,
        element: <AuthorizedRoute moduleIds={[ACCESSIBLE_MUDULE_KEYS.PAYMENT_RECEIVED]}><MyOrdersTable /></AuthorizedRoute>
    },
] 